import { cancelOrder } from "actions/balance";
import SageButton from "kit/SageButton";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import cancelOrderStatusSelector from "selectors/cancelOrderStatus";

interface Props {
    order: sage.model.IOrder;
}

const BalanceMinutesOrdersRecordRowCancelFooter: React.FC<Props> = ({
    order,
}) => {
    const dispatch = useDispatch();
    const cancelOrderStatus = useSelector(cancelOrderStatusSelector(order.id));

    const onCancelClicked = React.useCallback(() => {
        dispatch(cancelOrder(order.id));
    }, [dispatch, order.id]);

    if (!order.can_cancel) {
        return null;
    }

    if (cancelOrderStatus === "loading" || cancelOrderStatus === "none") {
        return (
            <SageButton
                onClick={onCancelClicked}
                className="btn-sm"
                theme="btn-secondary"
                text="Cancel"
                loading={cancelOrderStatus === "loading"}
            />
        );
    } else if (cancelOrderStatus === "error") {
        return (
            <p>
                <small className="text-danger">
                    An error occurred, please try again.
                </small>
            </p>
        );
    } else {
        return (
            <p>
                <small className="text-success">Cancelled successfully.</small>
            </p>
        );
    }
};

export default BalanceMinutesOrdersRecordRowCancelFooter;
